import * as React from 'react';
import ReactDOM from 'react-dom';

import HeaderNotificationContainer from 'components/notification/header/pc/HeaderNotificationContainer';

ReactDOM.render(<HeaderNotificationContainer />, document.getElementById('header-notification'));
